import React from "react";
import { Tooltip, IconButton, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { BiExport } from "react-icons/bi";
import * as XLSX from "xlsx";

const ExportButton = ({
  data,
  formatCsv,
  formatExcel,
  filename
}) => {
  const exportToCSV = () => {
    let csvContent = data;
    if (formatCsv) {
      csvContent = formatCsv(data);
    }
    const blob = new Blob([csvContent], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const exportToExcel = () => {
    let excelContent = data;
    if (formatExcel) {
      excelContent = formatExcel(data);
    }
    const ws = XLSX.utils.aoa_to_sheet(excelContent);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
  };

  return (
    <Tooltip shouldWrapChildren hasArrow  placement='top' label="Export to file">
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label='Export'
          icon={<BiExport />}
          variant='ghost'
          rounded="full"
        >
        </MenuButton>
        <MenuList>
          <MenuItem onClick={exportToExcel}>Export as Excel</MenuItem>
          <MenuItem onClick={exportToCSV}>Export as CSV</MenuItem>
        </MenuList>
      </Menu>
    </Tooltip>
  );
};

export default ExportButton;
